import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.css']
})
export class OrderConfirmationComponent implements OnInit {

  parentRouteParam !: any;
  orderno: any;
  public show = true;
    userRole: string;
  constructor(private activatedRoute: ActivatedRoute, private router: Router ) { }

  ngOnInit() {
    this.userRole = localStorage.getItem('role');
    if (this.activatedRoute.parent) {
      this.activatedRoute.parent.params.subscribe(params => {
        this.parentRouteParam = params['storename'];
      });
    }

    // this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   return true;
    // };

    // Accessing orderno from route params
    this.activatedRoute.params.subscribe(params => {
     this.orderno = params['orderno'];
    });
  }

  fn_RedirectToOrderList() {
    this.router.navigateByUrl(this.parentRouteParam + '/orders');
    this.router.navigate([this.parentRouteParam + '/orders']);
    this.show=false;
    
  }
  fn_RedirectToOrderDetail(orderNo: any) { 
      this.router.navigate([this.parentRouteParam + '/orderdetail', orderNo]);
   
  }
}
